<img [class]="classes"
    [src]="image() | imageUrl:transformations"
    [alt]="altText || image()?.alt_text"
>